export function cartCustomCheckout() {
  $(document).on(
    "click",
    "woocommerce-checkout .increment, woocommerce-checkout .decrement",
    function (e) {
      e.preventDefault();
      const $parentBox = $(this).closest(".product-box");
      const cartItemKey = $parentBox.data("cart-item-key");
      const $qtyInput = $parentBox.find(".quantity-input-checkout");
      let currentQty = parseInt($qtyInput.val());
      if ($(this).hasClass("increment")) {
        currentQty++;
      } else if ($(this).hasClass("decrement") && currentQty > 1) {
        currentQty--;
      }
      updateCartItemQuantity(cartItemKey, currentQty);
    }
  );

  $(document).on("change", ".quantity-input-checkout", function () {
    const $input = $(this);
    let newQty = parseInt($input.val());
    if (isNaN(newQty) || newQty < 1) {
      newQty = 1;
      $input.val(newQty);
    }

    const $parentBox = $input.closest(".product-box");
    const cartItemKey = $parentBox.data("cart-item-key");
    updateCartItemQuantity(cartItemKey, newQty);
  });

  // Função para atualizar quantidade via AJAX
  function updateCartItemQuantity(cartItemKey, newQty) {
    $("#loadingOverlay").show();
    $.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "update_cart_item_quantity",
        cart_item_key: cartItemKey,
        quantity: newQty,
      },
      success: function (response) {
        if (response.success) {
          // Atualiza o HTML do carrinho
          $("#customCartContainer").html(response.data.cart_html);
          // Atualiza o subtotal
          $("#cartSubtotal").html(response.data.subtotal);
        } else {
          console.log("Erro:", response.data);
        }
      },
      error: function (err) {
        console.log("Erro na requisição AJAX:", err);
      },
      complete: function () {
        // Independente de sucesso ou erro, oculta o loading
        $("#loadingOverlay").hide();
      },
    });
  }

  // Remover item
  $(document).on("click", ".remove-item", function (e) {
    e.preventDefault();
    const $parentBox = $(this).closest(".product-box");
    const cartItemKey = $parentBox.data("cart-item-key");

    $.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "remove_cart_item",
        cart_item_key: cartItemKey,
      },
      success: function (response) {
        if (response.success) {
          $("#customCartContainer").html(response.data.cart_html);
          $("#cartSubtotal").html(response.data.subtotal);
        } else {
          console.log("Erro:", response.data);
        }
      },
      error: function (err) {
        console.log("Erro na requisição AJAX:", err);
      },
    });
  });

  // Aplicar cupom
  $("#applyCouponBtn").on("click", function (e) {
    e.preventDefault();
    const couponCode = $("#couponCodeInput").val();

    $.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "apply_coupon_code",
        coupon_code: couponCode,
      },
      success: function (response) {
        if (response.success) {
          // Se deu certo, atualiza o carrinho
          $("#customCartContainer").html(response.data.cart_html);
          $("#cartSubtotal").html(response.data.subtotal);
        } else {
          // Exibe mensagem de erro vinda do PHP
          alert(response.data.message);
          // Ou você pode inserir a mensagem num elemento HTML
        }
      },
      error: function (err) {
        console.log("Erro na requisição AJAX:", err);
      },
    });
  });
}
